export default "__VITE_ASSET__03699dfd__"